/**
 * bunny.net Stream Analytics API
 * Metrics come from data sources with different prerequisites: some need only standard CDN request logging, others need CMCD v1 query-string enrichment or a CMCD v2 player beacon - see each endpoint\'s description for which. If its required source isn\'t enabled, an endpoint returns empty/zero results, not an error.
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { HttpClient, HttpContext, HttpEvent, HttpHeaders, HttpParameterCodec, HttpParams, HttpResponse } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';

import { Observable } from 'rxjs';

import { Configuration } from '../configuration';
import { CustomHttpParameterCodec } from '../encoder';
// @ts-ignore
import { CacheMissResponse } from '../model/cache-miss-response';
// @ts-ignore
import { CacheMissTimeSeriesResponse } from '../model/cache-miss-time-series-response';
// @ts-ignore
import { ContentTypeFilter } from '../model/content-type-filter';
// @ts-ignore
import { ErrorsResponse } from '../model/errors-response';
// @ts-ignore
import { ErrorsTimeSeriesResponse } from '../model/errors-time-series-response';
// @ts-ignore
import { StreamAnalyticsCmcdPostPullZoneIdParameter } from '../model/stream-analytics-cmcd-post-pull-zone-id-parameter';
// @ts-ignore
import { StreamAnalyticsV1PullZoneIdAudienceGeographyGetLimitParameter } from '../model/stream-analytics-v1-pull-zone-id-audience-geography-get-limit-parameter';
// @ts-ignore
import { TimeSeriesGranularity } from '../model/time-series-granularity';
// @ts-ignore
import { TrafficBreakdownDimension } from '../model/traffic-breakdown-dimension';
// @ts-ignore
import { TrafficBreakdownResponse } from '../model/traffic-breakdown-response';
// @ts-ignore
import { TrafficBytesScope } from '../model/traffic-bytes-scope';
// @ts-ignore
import { TrafficResponse } from '../model/traffic-response';
// @ts-ignore
import { TrafficTimeSeriesResponse } from '../model/traffic-time-series-response';
// @ts-ignore
import { BASE_PATH } from '../variables';

export interface StreamAnalyticsV1PullZoneIdDeliveryCacheGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  from: string;
  to: string;
  /** Restrict to specific live stream IDs (repeatable). Combine with videoId to correlate a live stream with its VOD recording - matches either. */
  liveId?: string[];
  /** Restrict to specific video IDs (repeatable). Combine with liveId to correlate a live stream with its VOD recording - matches either. */
  videoId?: string[];
  /** Restrict to live or VOD assets. Only applies when neither liveId nor videoId is given. */
  contentType?: ContentTypeFilter;
}

export interface StreamAnalyticsV1PullZoneIdDeliveryCacheTimeseriesGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  from: string;
  to: string;
  /** Restrict to specific live stream IDs (repeatable). Combine with videoId to correlate a live stream with its VOD recording - matches either. */
  liveId?: string[];
  /** Restrict to specific video IDs (repeatable). Combine with liveId to correlate a live stream with its VOD recording - matches either. */
  videoId?: string[];
  /** Restrict to live or VOD assets. Only applies when neither liveId nor videoId is given. */
  contentType?: ContentTypeFilter;
  /** Bucket width for the time series. More values may be added over time - treat this set as open, not exhaustive. */
  granularity?: TimeSeriesGranularity;
}

export interface StreamAnalyticsV1PullZoneIdDeliveryErrorsGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  from: string;
  to: string;
  /** Restrict to specific live stream IDs (repeatable). Combine with videoId to correlate a live stream with its VOD recording - matches either. */
  liveId?: string[];
  /** Restrict to specific video IDs (repeatable). Combine with liveId to correlate a live stream with its VOD recording - matches either. */
  videoId?: string[];
  /** Restrict to live or VOD assets. Only applies when neither liveId nor videoId is given. */
  contentType?: ContentTypeFilter;
}

export interface StreamAnalyticsV1PullZoneIdDeliveryErrorsTimeseriesGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  from: string;
  to: string;
  /** Restrict to specific live stream IDs (repeatable). Combine with videoId to correlate a live stream with its VOD recording - matches either. */
  liveId?: string[];
  /** Restrict to specific video IDs (repeatable). Combine with liveId to correlate a live stream with its VOD recording - matches either. */
  videoId?: string[];
  /** Restrict to live or VOD assets. Only applies when neither liveId nor videoId is given. */
  contentType?: ContentTypeFilter;
  /** Bucket width for the time series. More values may be added over time - treat this set as open, not exhaustive. */
  granularity?: TimeSeriesGranularity;
}

export interface StreamAnalyticsV1PullZoneIdDeliveryTrafficBreakdownGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  from: string;
  to: string;
  /** The dimension to group rows by, e.g. resolution or codec. More values may be added over time - treat this set as open, not exhaustive. */
  dimension: TrafficBreakdownDimension;
  /** Restrict to specific live stream IDs (repeatable). Combine with videoId to correlate a live stream with its VOD recording - matches either. */
  liveId?: string[];
  /** Restrict to specific video IDs (repeatable). Combine with liveId to correlate a live stream with its VOD recording - matches either. */
  videoId?: string[];
  /** Restrict to live or VOD assets. Only applies when neither liveId nor videoId is given. */
  contentType?: ContentTypeFilter;
  /** Narrows the byte total to streaming, storage, or all traffic. More values may be added over time - treat this set as open, not exhaustive. */
  bytesScope?: TrafficBytesScope;
  /** Maximum number of rows to return. */
  limit?: StreamAnalyticsV1PullZoneIdAudienceGeographyGetLimitParameter;
}

export interface StreamAnalyticsV1PullZoneIdDeliveryTrafficGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  from: string;
  to: string;
  /** Restrict to specific live stream IDs (repeatable). Combine with videoId to correlate a live stream with its VOD recording - matches either. */
  liveId?: string[];
  /** Restrict to specific video IDs (repeatable). Combine with liveId to correlate a live stream with its VOD recording - matches either. */
  videoId?: string[];
  /** Restrict to live or VOD assets. Only applies when neither liveId nor videoId is given. */
  contentType?: ContentTypeFilter;
  /** Narrows the byte total to streaming, storage, or all traffic. More values may be added over time - treat this set as open, not exhaustive. */
  bytesScope?: TrafficBytesScope;
}

export interface StreamAnalyticsV1PullZoneIdDeliveryTrafficTimeseriesGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  from: string;
  to: string;
  /** Restrict to specific live stream IDs (repeatable). Combine with videoId to correlate a live stream with its VOD recording - matches either. */
  liveId?: string[];
  /** Restrict to specific video IDs (repeatable). Combine with liveId to correlate a live stream with its VOD recording - matches either. */
  videoId?: string[];
  /** Restrict to live or VOD assets. Only applies when neither liveId nor videoId is given. */
  contentType?: ContentTypeFilter;
  /** Bucket width for the time series. More values may be added over time - treat this set as open, not exhaustive. */
  granularity?: TimeSeriesGranularity;
  /** Narrows the byte total to streaming, storage, or all traffic. More values may be added over time - treat this set as open, not exhaustive. */
  bytesScope?: TrafficBytesScope;
}

@Injectable({
  providedIn: 'root',
})
export class DeliveryService {
  protected basePath = 'https://mc-cwlfiqxct9.bunny.run';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach((elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach((k) => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k)));
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * Cache-miss request count
   * Counts requests that missed cache between \&#39;from\&#39; and \&#39;to\&#39;.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdDeliveryCacheGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryCacheGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<CacheMissResponse>;
  public streamAnalyticsV1PullZoneIdDeliveryCacheGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryCacheGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<CacheMissResponse>>;
  public streamAnalyticsV1PullZoneIdDeliveryCacheGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryCacheGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<CacheMissResponse>>;
  public streamAnalyticsV1PullZoneIdDeliveryCacheGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryCacheGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdDeliveryCacheGet.');
    }
    const from = requestParameters?.from;
    if (from === null || from === undefined) {
      throw new Error('Required parameter from was null or undefined when calling streamAnalyticsV1PullZoneIdDeliveryCacheGet.');
    }
    const to = requestParameters?.to;
    if (to === null || to === undefined) {
      throw new Error('Required parameter to was null or undefined when calling streamAnalyticsV1PullZoneIdDeliveryCacheGet.');
    }
    const liveId = requestParameters?.liveId;
    const videoId = requestParameters?.videoId;
    const contentType = requestParameters?.contentType;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (from !== undefined && from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>from, 'from');
    }
    if (to !== undefined && to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>to, 'to');
    }
    if (liveId) {
      liveId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'liveId');
      });
    }
    if (videoId) {
      videoId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'videoId');
      });
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/delivery/cache`;
    return this.httpClient.request<CacheMissResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Cache misses bucketed over time
   * Buckets cache-miss request counts into \&#39;granularity\&#39;-sized time slices between \&#39;from\&#39; and \&#39;to\&#39;.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdDeliveryCacheTimeseriesGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryCacheTimeseriesGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<CacheMissTimeSeriesResponse>;
  public streamAnalyticsV1PullZoneIdDeliveryCacheTimeseriesGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryCacheTimeseriesGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<CacheMissTimeSeriesResponse>>;
  public streamAnalyticsV1PullZoneIdDeliveryCacheTimeseriesGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryCacheTimeseriesGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<CacheMissTimeSeriesResponse>>;
  public streamAnalyticsV1PullZoneIdDeliveryCacheTimeseriesGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryCacheTimeseriesGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdDeliveryCacheTimeseriesGet.');
    }
    const from = requestParameters?.from;
    if (from === null || from === undefined) {
      throw new Error('Required parameter from was null or undefined when calling streamAnalyticsV1PullZoneIdDeliveryCacheTimeseriesGet.');
    }
    const to = requestParameters?.to;
    if (to === null || to === undefined) {
      throw new Error('Required parameter to was null or undefined when calling streamAnalyticsV1PullZoneIdDeliveryCacheTimeseriesGet.');
    }
    const liveId = requestParameters?.liveId;
    const videoId = requestParameters?.videoId;
    const contentType = requestParameters?.contentType;
    const granularity = requestParameters?.granularity;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (from !== undefined && from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>from, 'from');
    }
    if (to !== undefined && to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>to, 'to');
    }
    if (liveId) {
      liveId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'liveId');
      });
    }
    if (videoId) {
      videoId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'videoId');
      });
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }
    if (granularity !== undefined && granularity !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>granularity, 'granularity');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/delivery/cache/timeseries`;
    return this.httpClient.request<CacheMissTimeSeriesResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Error request count
   * Counts requests that returned a 4xx/5xx status between \&#39;from\&#39; and \&#39;to\&#39;.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdDeliveryErrorsGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryErrorsGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<ErrorsResponse>;
  public streamAnalyticsV1PullZoneIdDeliveryErrorsGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryErrorsGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<ErrorsResponse>>;
  public streamAnalyticsV1PullZoneIdDeliveryErrorsGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryErrorsGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<ErrorsResponse>>;
  public streamAnalyticsV1PullZoneIdDeliveryErrorsGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryErrorsGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdDeliveryErrorsGet.');
    }
    const from = requestParameters?.from;
    if (from === null || from === undefined) {
      throw new Error('Required parameter from was null or undefined when calling streamAnalyticsV1PullZoneIdDeliveryErrorsGet.');
    }
    const to = requestParameters?.to;
    if (to === null || to === undefined) {
      throw new Error('Required parameter to was null or undefined when calling streamAnalyticsV1PullZoneIdDeliveryErrorsGet.');
    }
    const liveId = requestParameters?.liveId;
    const videoId = requestParameters?.videoId;
    const contentType = requestParameters?.contentType;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (from !== undefined && from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>from, 'from');
    }
    if (to !== undefined && to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>to, 'to');
    }
    if (liveId) {
      liveId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'liveId');
      });
    }
    if (videoId) {
      videoId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'videoId');
      });
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/delivery/errors`;
    return this.httpClient.request<ErrorsResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Errors bucketed over time
   * Buckets 4xx/5xx request counts into \&#39;granularity\&#39;-sized time slices between \&#39;from\&#39; and \&#39;to\&#39;.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdDeliveryErrorsTimeseriesGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryErrorsTimeseriesGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<ErrorsTimeSeriesResponse>;
  public streamAnalyticsV1PullZoneIdDeliveryErrorsTimeseriesGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryErrorsTimeseriesGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<ErrorsTimeSeriesResponse>>;
  public streamAnalyticsV1PullZoneIdDeliveryErrorsTimeseriesGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryErrorsTimeseriesGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<ErrorsTimeSeriesResponse>>;
  public streamAnalyticsV1PullZoneIdDeliveryErrorsTimeseriesGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryErrorsTimeseriesGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdDeliveryErrorsTimeseriesGet.');
    }
    const from = requestParameters?.from;
    if (from === null || from === undefined) {
      throw new Error('Required parameter from was null or undefined when calling streamAnalyticsV1PullZoneIdDeliveryErrorsTimeseriesGet.');
    }
    const to = requestParameters?.to;
    if (to === null || to === undefined) {
      throw new Error('Required parameter to was null or undefined when calling streamAnalyticsV1PullZoneIdDeliveryErrorsTimeseriesGet.');
    }
    const liveId = requestParameters?.liveId;
    const videoId = requestParameters?.videoId;
    const contentType = requestParameters?.contentType;
    const granularity = requestParameters?.granularity;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (from !== undefined && from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>from, 'from');
    }
    if (to !== undefined && to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>to, 'to');
    }
    if (liveId) {
      liveId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'liveId');
      });
    }
    if (videoId) {
      videoId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'videoId');
      });
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }
    if (granularity !== undefined && granularity !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>granularity, 'granularity');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/delivery/errors/timeseries`;
    return this.httpClient.request<ErrorsTimeSeriesResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Bytes served grouped by dimension
   * Groups bytes, requests, cache misses, and errors by the given dimension (e.g. resolution, country) between \&#39;from\&#39; and \&#39;to\&#39;.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdDeliveryTrafficBreakdownGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryTrafficBreakdownGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<TrafficBreakdownResponse>;
  public streamAnalyticsV1PullZoneIdDeliveryTrafficBreakdownGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryTrafficBreakdownGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<TrafficBreakdownResponse>>;
  public streamAnalyticsV1PullZoneIdDeliveryTrafficBreakdownGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryTrafficBreakdownGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<TrafficBreakdownResponse>>;
  public streamAnalyticsV1PullZoneIdDeliveryTrafficBreakdownGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryTrafficBreakdownGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdDeliveryTrafficBreakdownGet.');
    }
    const from = requestParameters?.from;
    if (from === null || from === undefined) {
      throw new Error('Required parameter from was null or undefined when calling streamAnalyticsV1PullZoneIdDeliveryTrafficBreakdownGet.');
    }
    const to = requestParameters?.to;
    if (to === null || to === undefined) {
      throw new Error('Required parameter to was null or undefined when calling streamAnalyticsV1PullZoneIdDeliveryTrafficBreakdownGet.');
    }
    const dimension = requestParameters?.dimension;
    if (dimension === null || dimension === undefined) {
      throw new Error('Required parameter dimension was null or undefined when calling streamAnalyticsV1PullZoneIdDeliveryTrafficBreakdownGet.');
    }
    const liveId = requestParameters?.liveId;
    const videoId = requestParameters?.videoId;
    const contentType = requestParameters?.contentType;
    const bytesScope = requestParameters?.bytesScope;
    const limit = requestParameters?.limit;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (from !== undefined && from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>from, 'from');
    }
    if (to !== undefined && to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>to, 'to');
    }
    if (dimension !== undefined && dimension !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>dimension, 'dimension');
    }
    if (liveId) {
      liveId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'liveId');
      });
    }
    if (videoId) {
      videoId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'videoId');
      });
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }
    if (bytesScope !== undefined && bytesScope !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>bytesScope, 'bytesScope');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/delivery/traffic/breakdown`;
    return this.httpClient.request<TrafficBreakdownResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Bytes served in a time range
   * Sums bytes served between \&#39;from\&#39; and \&#39;to\&#39;. bytesScope narrows to streaming, storage, or all traffic.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdDeliveryTrafficGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryTrafficGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<TrafficResponse>;
  public streamAnalyticsV1PullZoneIdDeliveryTrafficGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryTrafficGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<TrafficResponse>>;
  public streamAnalyticsV1PullZoneIdDeliveryTrafficGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryTrafficGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<TrafficResponse>>;
  public streamAnalyticsV1PullZoneIdDeliveryTrafficGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryTrafficGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdDeliveryTrafficGet.');
    }
    const from = requestParameters?.from;
    if (from === null || from === undefined) {
      throw new Error('Required parameter from was null or undefined when calling streamAnalyticsV1PullZoneIdDeliveryTrafficGet.');
    }
    const to = requestParameters?.to;
    if (to === null || to === undefined) {
      throw new Error('Required parameter to was null or undefined when calling streamAnalyticsV1PullZoneIdDeliveryTrafficGet.');
    }
    const liveId = requestParameters?.liveId;
    const videoId = requestParameters?.videoId;
    const contentType = requestParameters?.contentType;
    const bytesScope = requestParameters?.bytesScope;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (from !== undefined && from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>from, 'from');
    }
    if (to !== undefined && to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>to, 'to');
    }
    if (liveId) {
      liveId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'liveId');
      });
    }
    if (videoId) {
      videoId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'videoId');
      });
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }
    if (bytesScope !== undefined && bytesScope !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>bytesScope, 'bytesScope');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/delivery/traffic`;
    return this.httpClient.request<TrafficResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Bytes served bucketed over time
   * Buckets bytes served into \&#39;granularity\&#39;-sized time slices between \&#39;from\&#39; and \&#39;to\&#39;.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdDeliveryTrafficTimeseriesGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryTrafficTimeseriesGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<TrafficTimeSeriesResponse>;
  public streamAnalyticsV1PullZoneIdDeliveryTrafficTimeseriesGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryTrafficTimeseriesGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<TrafficTimeSeriesResponse>>;
  public streamAnalyticsV1PullZoneIdDeliveryTrafficTimeseriesGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryTrafficTimeseriesGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<TrafficTimeSeriesResponse>>;
  public streamAnalyticsV1PullZoneIdDeliveryTrafficTimeseriesGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdDeliveryTrafficTimeseriesGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdDeliveryTrafficTimeseriesGet.');
    }
    const from = requestParameters?.from;
    if (from === null || from === undefined) {
      throw new Error('Required parameter from was null or undefined when calling streamAnalyticsV1PullZoneIdDeliveryTrafficTimeseriesGet.');
    }
    const to = requestParameters?.to;
    if (to === null || to === undefined) {
      throw new Error('Required parameter to was null or undefined when calling streamAnalyticsV1PullZoneIdDeliveryTrafficTimeseriesGet.');
    }
    const liveId = requestParameters?.liveId;
    const videoId = requestParameters?.videoId;
    const contentType = requestParameters?.contentType;
    const granularity = requestParameters?.granularity;
    const bytesScope = requestParameters?.bytesScope;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (from !== undefined && from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>from, 'from');
    }
    if (to !== undefined && to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>to, 'to');
    }
    if (liveId) {
      liveId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'liveId');
      });
    }
    if (videoId) {
      videoId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'videoId');
      });
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }
    if (granularity !== undefined && granularity !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>granularity, 'granularity');
    }
    if (bytesScope !== undefined && bytesScope !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>bytesScope, 'bytesScope');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/delivery/traffic/timeseries`;
    return this.httpClient.request<TrafficTimeSeriesResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }
}
